import { useState } from "react";
import { Link } from "react-router-dom";
import "./menu.scss";
import menuData from "../../data";

const Menu = ()=> {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };

  return (
    <div className="menu">
      {menuData.map((section) => (
        <div className="menuItem" key={section.id}>
          <span className="title">{section.title.toLocaleUpperCase()}</span>

          {section.menuItems.map((mItem) => (
            <div key={mItem.id} className="itemWrapper">
              {mItem.galleryItem ? (
                // Parent item with arrow toggle
                <div
                  className="itemLink"
                  onClick={() => toggleMenu(mItem.id)}
                >
                  <img src={mItem.icon} width={24} height={24} alt="" />
                  <span className="listItemTitle">{mItem.title}</span>
                  <span className="arrow">
                    {openMenu === mItem.id ? "▼" : "►"}
                  </span>
                </div>
              ) : (
                // Normal link
                <Link to={mItem.url} className="itemLink">
                  <img src={mItem.icon} width={24} height={24} alt="" />
                  <span className="listItemTitle">{mItem.title}</span>
                </Link>
              )}

              {/* Collapsible submenu */}
              {mItem.galleryItem && openMenu === mItem.id && (
                <div className="subMenu">
                  {mItem.galleryItem.map((subItem) => (
                    <Link
                      to={subItem.url}
                      className="subItemLink"
                      key={subItem.id}
                    >
                      <img src={subItem.icon} width={20} height={20} alt="" />
                      <span className="subItemTitle">{subItem.title}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default Menu;
